import React from 'react';
import { Button } from '../../../../../base/components/Button';
import { Modal } from '../../../../../base/components/Modal';
import { __t } from '../../../../../base/utils/t';

import './styles.scss';

interface Props {
    visible: boolean;
    visibilityHandler: () => void;
    onConfirmLeave: () => void;
}

export const UnsavedChangesModal = ({ visible, visibilityHandler, onConfirmLeave }: Props) => {
    return (
        <Modal visible={visible} visibilityHandler={visibilityHandler} className='unsaved-changes-modal'>
            <p className='unsaved-changes-modal__title'>{__t('Дані не збережено')}</p>
            <p className='unsaved-changes-modal__text'>
                {__t('Ваша вакансія не збережена.')}
                <br />
                {__t('Якщо вийти зараз, усі введені дані буде втрачено.')}
            </p>
            <div className='unsaved-changes-modal__buttons'>
                <Button type='secondary' onClick={visibilityHandler} className='unsaved-changes-modal__button'>
                    {__t('Редагувати')}
                </Button>
                <Button type='primary' onClick={onConfirmLeave} className='unsaved-changes-modal__button'>
                    {__t('Вийти')}
                </Button>
            </div>
        </Modal>
    );
};
